export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#4285F4" />
    <path d="M14 22c2.6-2.6 6-4 9.5-4" stroke="#fff" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.9" />
    <path d="M14 29c1.7-1.7 3.9-2.6 6.2-2.6" stroke="#fff" strokeWidth="3" strokeLinecap="round" fill="none" opacity="0.7" />
    <path transform="translate(21 20) scale(1.05)" fill="#FBBC04" d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5" data-testid="logo">
    <LogoMark />
    <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
      Tap<span className="text-[#4285F4]">Google</span>
      <span className="text-sm font-bold text-slate-400">.com</span>
    </span>
  </span>
);
